import type { LinkableCard, LinkableItem, LinkableObjective } from "@/model/link";

export function isStickyLink(link: LinkableItem): link is LinkableCard {
  return link.kind === "sticky";
}

export function isARTWorkItem(link: LinkableItem): link is LinkableCard {
  return link.kind === "sticky" && isARTOrigin(link.type.origin) && !isDependency(link);
}

/** Returns true if the board origin is an ART-level type (backlog, program, risk). */
export function isARTOrigin(origin: string): boolean {
  return ["backlog", "program", "risk"].includes(origin);
}

export function isDependency(link: LinkableItem): link is LinkableCard {
  return link.kind === "sticky" && link.type.functionality === "dependency";
}

export function isTeamWorkItem(link: LinkableItem): link is LinkableCard {
  return link.kind === "sticky" && link.type.origin === "team" && !isDependency(link);
}

export function isOtherItem(link: LinkableItem): link is LinkableCard {
  return (
    link.kind === "sticky" && !isARTWorkItem(link) && !isDependency(link) && !isTeamWorkItem(link)
  );
}

export function isObjective(link: LinkableItem): link is LinkableObjective {
  return link.kind === "objective";
}
